import { AnnouncementSectionTitle } from './announcement-section-title';
import { AnnouncementShareToSelect } from './announcement-share-to-select';

export function AnnouncementAudienceSection() {
  return (
    <section className='flex w-full flex-col gap-4 rounded-xl border border-primary-100 bg-white p-6'>
      <AnnouncementSectionTitle title='4. Audience Details' />
      <AnnouncementShareToSelect />
    </section>
  );
}
